"use client"

import { replaceScriptNode } from "@/app/(site)/[locale]/checkout/centra/utils/replaceScriptNode"
import { useEffect, useRef } from "react"

export interface CentraCheckoutScriptProps {
    // callback: (origdata: Record<string, any>) => void
    formHtml: string | null
}

export interface IngridProps {
    data: Record<string, unknown>
    onError: (data: any) => void
    onLoaded: (data: { shippingMethodId?: string }) => void
    onChange: (data: { shippingMethodId: string }) => void
    onMounted: () => void
    disabled?: boolean
}

export type Ingridv1Key = "shipwallet"
export type Ingridv2Key = "ingrid"

export const reInitiateIngridEvents = (id: Ingridv1Key | Ingridv2Key) =>
    window?.CentraCheckout?.reInitiate?.(id)

export const reInitiateKlarnaEvents = () => window?.CentraCheckout?.reInitiate?.("klarna")

export const CentraCheckoutScript = ({
    // callback,
    formHtml
}: CentraCheckoutScriptProps) => {
    const htmlAdyenDropInReference = useRef<HTMLDivElement>(null)

    useEffect(() => window?.CentraCheckout?.destroy, [])

    // only used in combination with Adyen Drop-in and Ingrid/Klarna checkout
    // useEffect(() => {
    //     document.addEventListener("centra_checkout_callback", callback)
    //     return () => document.removeEventListener("centra_checkout_callback", callback)
    // }, [])

    useEffect(() => {
        if (!!htmlAdyenDropInReference?.current && formHtml) {
            htmlAdyenDropInReference.current.innerHTML = formHtml
            replaceScriptNode(htmlAdyenDropInReference.current)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formHtml, htmlAdyenDropInReference.current])

    return <div className="hidden" ref={htmlAdyenDropInReference} />
}
